import React from 'react';
import { HeroVariant31 } from '../components/HeroVariant31';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage31() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1597">
      <Navigation data-id="element-1598" />
      <main data-id="element-1599">
        <HeroVariant31 data-id="element-1600" />
        <WhyUs data-id="element-1601" />
        <Services data-id="element-1602" />
        <FAQ data-id="element-1603" />
        <Testimonials data-id="element-1604" />
        <Consultation data-id="element-1605" />
      </main>
      <Footer data-id="element-1606" />
      <CookieBanner data-id="element-1607" />
      <FloatingContact data-id="element-1608" />
    </div>;
}